const colors = {
  primary: "#b32c50",
  light: "#ffffff",
  dark: "#000000",
  bg: "#f5f5f5"
};

export { colors };
